import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=71c0e312&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=71c0e312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0e312",
  null
  
)

export default component.exports